module.exports = __webpack_public_path__ + "static/timescale-f52629a133a9010217905008105b9e24.svg";